import ptBR from 'vee-validate/dist/locale/pt_BR.json'

export default {
    validation: ptBR.messages,
    Titles: {
        recentAssessments: 'Avaliações recém-finalizadas',
        filters: 'Filtrar',
        ambientMode: 'Demonstração',
    },
    Alerts: {
        congrats: 'Parabéns!',
        congratsNewLevel: 'Parabéns, você avançou para o nível {level}',
        deletePicture: 'Essa foto não poderá ser recuperada',
        noAddress: 'Perfil sem informações de endereço',
        yourEmail: 'Seu email',
        unsavedChanges:
            'Você tem mudanças não salvas. Gostaria de salvá-las antes de sair?',
        removeProfile: 'Você está removendo um perfil da {location}',
        inactiveAttendance: 'Alunos inativos não podem fazer chamada',
        askChangeDate: 'Você tem certeza que quer trocar a data?',
        deactivateClass: 'Essa turma não aparecerá mais no mapa de ocupação',
        askNewAttendance: 'Fazer outra chamada?',
        attendanceLost: 'As chamadas não salvas serão perdidas!',
        noImage: 'O arquivo precisa ser uma imagem',
        copyToClipboard: 'Copiado para a área de transferência',
        saveSuccess: 'Salvo com sucesso',
        changedSuccess: 'Alterado com sucesso',
        createdSuccess: 'Criado com sucesso',
        deletedSuccess: 'Deletado com sucesso',
        removedSuccess: 'Removido com sucesso',
        sendSuccess: 'Enviado com sucesso',
        sure: 'Você tem certeza?',
        irreversible: 'Essa ação é irreversível!',
        cancel: 'Cancelar',
        no: 'Não',
        yes: 'Sim',
        deleteAction: 'Confirmar',
        userError: 'Algo deu errado, tente novamente mais tarde.',
        usersLimit:
            'Você atingiu o limite de cadastro em seu plano, entre em contato com seu Customer Success',
        noProfileSelected: 'É preciso selecionar um perfil',
        cantDeleteYourself:
            'Você não pode desativar/deletar o seu próprio perfil',
        cantInactivateLoggedLocation:
            'Não é possível inativar a mesma unidade que você fez login',
        askDeactivate: 'Deseja mesmo inativar este cadastro?',
        warningDeactivate: 'Ele(a) não poderá mais acessar a plataforma',
        askDeactivateLocation: 'Deseja mesmo inativar este unidade?',
        warningDeactivateLocation:
            'Todas as pessoas cadastradas nesta unidade perderão o acesso!',
        sessionExpired: 'Sua sessão expirou, por favor entre novamente.',
        cantChangeProfile:
            'Não é possível alterar um perfil em um usuário desativado.',
        deleteAlert: 'Para deletar o(s) registro(s) clique no botão Deletar.',
        selectUsersToDelete: 'Selecione os registros que deseja deletar',
        saveFirst: 'Para prosseguir, é necessário salvar.',
        selectAll: 'Selecione todos os itens antes de adicionar.',
        registerLesson: 'Cadastre ao menos uma aula antes de salvar.',
        accessDenied: 'Você não permissão para essa funcionalidade.',
        notFound: 'Página não encontrada',
        serverError:
            'Ocorreu um erro no servidor, por favor tente novamente mais tarde',
        responsibleAlreadyIncluded:
            'Esse responsável já está cadastrado nesse aluno!',
        studentAlreadyIncluded:
            'Esse aluno já está cadastrado nesse responsável!',
        maxLevelStudents: 'Recomendamos {maxStudents} alunos para este nível',
        selectLevelFirst: 'Selecione um nível antes de escolher os alunos',
        diferentLevel: 'Esse aluno está em um nível diferente da turma',
        studentAlreadyIncludedInClass:
            'Esse aluno já está incluído nessa turma',
        changingLevelClass:
            'Tem certeza que deseja trocar o nível dessa turma?',
        removeStudents: 'Todos os alunos antigos serão retirados',
        checkAllStudents:
            'Todos os alunos devem ter presença ou falta antes salvar',
        onlyActiveUsers: 'Somente usuários ativos podem ser adicionados',
        noQuestions:
            'Não é possível tornar vigente um modelo de avaliação sem perguntas',
        activeAssessment:
            'Ao tornar vigente essa avaliação, você não poderá mais editá-la',
        selectItemsFirst: 'Selecione os itens que serão deletados',
        selectStudents: 'Selecione os alunos para fazer a avaliação',
        selectStudentsToAttendance: 'Selecione os alunos para fazer a chamada',
        studentWithoutAnswer:
            'Antes de continuar, insira o resultado de todos os alunos',
        pauseAlert: 'Você irá pausar a avaliação deste aluno',
        pauseDescription: 'Mas poderá continuar a avaliação dele mais tarde',
        studentsWithoutComments:
            'Alunos marcados com "Sim" devem ter comentário',
        studentsNoCheck:
            'Antes de prosseguir, marque os alunos que tem ou não comentários',
        deleteFolder:
            'Você deletará essa pasta e todo o conteúdo dela. Essa ação é irreversível.',
        selectFile: 'Selecione o arquivo para salvar',
        invalidDateValue: 'Intervalo de tempo inválido',
        maxSize: 'Só é possível salvar arquivos de até 10MB',
        cantDownload: 'Você não tem permissão para baixar esse arquivo',
        changePasswordSuccess: 'Senha alterada com sucesso',
        cantEditAssessment: 'Avaliação Finalizada não pode ser editada.',
        goToNewAssessments:
            'Utilize as avaliações através do novo painel, basta acessar "Novo painel" no menu e clicar em "Acessar painel".',
        wantDoAssessment: 'Quer fazer uma avaliação?',
    },
    Menu: {
        profile: 'Meu perfil',
        attendance: 'Chamada',
        occupancyMap: 'Mapa de ocupação',
        partners: 'Parceiros',
        newPartner: 'Novo parceiro',
        editPartner: 'Editar parceiro',
        integration: 'Integração',
        newIntegration: 'Nova integração',
        partnerManagement: 'Gerenciador de integrações',
        newPartnerToken: 'Novo token para parceiro',
        students: 'Alunos',
        newStudent: 'Novo aluno',
        editStudent: 'Editar aluno',
        classLesson: 'Aula',
        responsible: 'Responsáveis',
        newResponsible: 'Novo responsável',
        editResponsible: 'Editar responsável',
        classgrade: 'Aulas/Turmas',
        newClassgrade: 'Criar nova turma',
        editClassGrade: 'Editar turma',
        emailFormat: 'Este campo deve ter um formato de email',
        teachingAreas: 'Piscinas',
        newTeachingAreas: 'Criar nova piscina',
        editTeachingAreas: 'Editar piscina',
        team: 'Equipe',
        newTeam: 'Criar novo membro da equipe',
        editTeam: 'Editar um membro da equipe',
        assessmentStudents: 'Avaliações',
        assessmentStudentsNewModule: 'Novo painel',
        assessmentResult: 'Resultado da avaliação',
        assessmentApplication: 'Aplicando avaliação',
        showStores: 'Minhas Lojas',
        SubItems: {
            pedagogic: 'Pedagógico',
            configurations: 'Configurações',
        },
        goals: 'Objetivos',
        newGoal: 'Novo objetivo',
        editGoal: 'Editar objetivo',
        contents: 'Conteúdos',
        newContent: 'Novo conteúdo',
        editContent: 'Editar conteúdo',
        scheduleMap: 'Calendário de objetivos',
        newScheduleMap: 'Novo calendário de objetivos',
        newLesson: 'Nova aula',
        editLesson: 'Editar aula',
        editScheduleMap: 'Editar calendário de objetivos',
        assessmentModel: 'Modelos de avaliação',
        newAssessmentModel: 'Novo modelo de avaliação',
        editAssessmentModel: 'Editar modelo de avaliação',
        newAssessmentQuestion: 'Nova pergunta',
        editAssessmentQuestion: 'Editar pergunta',
        plans: 'Planos',
        newPlans: 'Criar um novo plano',
        editPlan: 'Editar o plano',
        clients: 'Credenciados',
        newClient: 'Novo credenciado',
        editClient: 'Editar credenciado',
        locations: 'Unidades',
        newLocation: 'Criar uma nova unidade',
        editLocation: 'Editar a unidade',
        locationBuyers: 'Lojistas',
        newLocationBuyer: 'Criar um novo lojista',
        editLocationBuyer: 'Editar lojista',
        staff: 'Staff',
        newStaff: 'Novo staff',
        editStaff: 'Editar staff',
        uploads: 'Gerenciador de arquivos',
        downloads: 'Downloads',
        courses: 'Cursos',
        certification: 'Certificação',
        faq: 'Dúvidas',
    },
    Errors: {
        notImage: 'Sem imagem',
        invalidLogin: 'E-mail ou senha inválidos',
        minValue: 'Insira um valor maior que 0',
        accessDenied: 'Usuário não tem perfil com acesso à ferramenta',
        selectLocation: 'Selecione uma unidade antes de continuar',
        emailNotFound: 'E-mail não cadastrado',
        invalidDate: 'Digite uma data válida',
        requiredField: 'Este campo é obrigatório',
        emailFormat: 'Este campo deve ter o formato ***@***.***',
        invalidCep: 'Digite um cep válido',
        dateFromToday: 'Data a partir de hoje',
        error_400: {
            title: 'Erro de requisição',
            description: '',
        },
        error_401: {
            title: 'Não autorizado',
            description: '',
        },
        error_403: {
            title: 'Acesso proibido',
            description: '',
        },
        error_404: {
            title: 'Página não encontrada',
            description:
                'A página que você está procurando não está mais disponível',
        },
        error_500: {
            title: 'Erro no servidor',
            description: 'Tente novamente mais tarde',
        },
        invalidHours: 'Digite um intervalo válido de horas',
        invalidHour: 'Digite uma hora valida',
        typePositiveNumber: 'O numbero de alunos tem que ser maior do que 0',
        inactiveUser: 'Selecione uma opção ativa para continuar.',
        invalidCPF: 'O CPF está incompleto; ele deve ter 11 números',
        invalidCNPJ: 'O CNPJ está incompleto; deve ter 14 números',
        specialCharacter: 'Não é permitido o uso de caracteres especiais',
        passwordLengthRule: 'A senha deve ter entre 8 e 100 caracteres.',
    },
    Language: {
        portuguese: 'Português',
        spanish: 'Espanhol',
        english: 'Inglês',
    },
    Login: {
        welcome: 'Seja Bem-Vindo',
        presentationText:
            'Faça a gestão de suas unidades e clientes, de forma fácil, visual e intuitiva.',
        quote: 'A educação por meio da natação.',
        forgotPassword: 'Esqueceu sua senha?',
        insertEmail: 'Informe o seu e-mail para resetar sua senha:',
        chooseLocation: 'Escolha uma unidade',
        locationText: 'Antes de acessar, escolha a unidade na lista abaixo',
        insertPassword: 'Nova senha',
        successNewPassword: 'Senha alterada com sucesso.',
        resetPasswordInform:
            'Estamos verificando se o e-mail {userEmail} está cadastrado em nossa plataforma, caso esteja, será enviando um e-mail com as instruções e o link para você trocar a senha.',
    },
    Fields: {
        names: {
            email: 'E-mail',
            password: 'Senha',
        },
        labels: {
            replace: 'Reposição',
            email: 'E-mail',
            password: 'Senha',
            users: 'Usuários',
            students: 'Alunos',
            points: 'Pontos',
            inactive: 'INATIVO',
            yes: 'Sim',
            no: 'Não',
            achievement: 'aproveitamento',
            uploadFile:
                'Arraste um arquivo para cá ou clique para selecionar um arquivo',
            characters: 'caracteres',
            items: 'Itens',
            currentPassword: 'Senha atual',
            newPassword: 'Nova senha',
            confirmPassword: 'Confirmar nova senha',
        },
        select: {
            searchStudent: 'Busque pelo nome do aluno',
            selectLabel: 'Selecionar',
            deselectLabel: 'Remover',
            noResult: 'Sem resultados para a pesquisa',
            noOptions: 'A lista está vazia',
            selectOption: 'Selecione uma opção',
            searchOption: 'Digite a sua busca aqui',
            locationPlaceholder: 'Selecione uma unidade',
            selected: 'Selecionado',
            other: 'Outro',
            male: 'Masculino',
            female: 'Feminino',
            searchHere: 'Sua busca aparecerá aqui',
            selectAll: 'Selecionar todos',
            options: {
                Permission: [
                    {
                        name: 'Público',
                        value: 0,
                    },
                    {
                        name: 'Privado',
                        value: 1,
                    },
                ],
                Situation: [
                    {
                        name: 'Ativo',
                        value: true,
                    },
                    {
                        name: 'Inativo',
                        value: false,
                    },
                ],
                UnitTypes: [
                    {
                        name: 'Academia',
                        value: 1,
                    },
                    {
                        name: 'Escola',
                        value: 2,
                    },
                    {
                        name: 'Clube',
                        value: 3,
                    },
                ],
                Entity: [
                    {
                        name: 'Pessoa fisíca / CPF',
                        value: 1,
                    },
                    {
                        name: 'Pessoa jurídica / CNPJ',
                        value: 2,
                    },
                    {
                        name: 'Internacional',
                        value: 3,
                    },
                ],
                QuestionItemType: [
                    {
                        name: 'Executa',
                        value: 0,
                    },
                    {
                        name: 'Valor',
                        value: 1,
                    },
                    {
                        name: 'Tempo',
                        value: 2,
                    },
                ],
            },
        },
        placeholder: {
            newPassword: 'Nova senha',
            typeQuery: 'Digite sua pesquisa',
        },
        values: {
            copyOf: 'Cópia de',
        },
        filters: {
            filterText: 'Filtros',
        },
    },
    Buttons: {
        choosePhoto: 'Escolher foto',
        cutAndSave: 'Cortar e salvar',
        reset: 'Resetar',
        changePhoto: 'Trocar foto',
        removePhoto: 'Remover foto',
        myProfile: 'Meu perfil',
        changeDate: 'Trocar a data',
        doAttendance: 'Fazer chamada',
        send: 'Enviar',
        resendEmail: 'Resetar senha',
        copyToken: 'Copiar token',
        back: 'Voltar',
        logIn: 'Entrar',
        continue: 'Continuar',
        save: 'Salvar',
        exit: 'Sair',
        changeLocation: 'Trocar de unidade',
        pagination: 'Ver mais',
        new: 'Novo',
        doAssessment: 'Fazer avaliação',
        continueAssessment: 'Continuar avaliação',
        addLessons: 'Adicionar aulas',
        update: 'Atualizar',
        newResponsible: 'Cadastrar novo responsável',
        newStudent: 'Cadastrar aluno',
        newLocation: 'Criar nova unidade',
        today: 'Hoje',
        saveAttendance: 'Salvar chamada',
        inactive: 'Inativo',
        shopkeeper: 'Lojista',
        newQuestion: 'Cadastrar pergunta',
        addArchive: 'Adicionar arquivo',
        filter: 'Filtrar',
        cleanFilter: 'Limpar filtros',
        changeImage: 'Trocar/remover foto',
        accessEcommerce: 'Acessar Ecommerce',
        changePassword: 'Trocar senha',
        add: 'Adicionar',
        edit: 'Editar',
        clone: 'Duplicar',
        delete: 'Deletar',
        pause: 'Pausar',
    },
    Table: {
        noData: 'Sem dados',
        noEmail: 'Não cadastrado',
        noImage: 'Sem logo',
        titles: {
            studentsLimit: 'Limite de alunos',
            employeesLimit: 'Limite de funcionários',
            partner: 'Parceiro',
            private: 'Privado',
            location: 'Unidade',
            releaseDate: 'Data de lançamento',
            generationDate: 'Data de geração',
            name: 'Nome',
            nameClassGrade: 'Nome da turma',
            buyer: 'Comprador',
            evaluator: 'Avaliador',
            asssessmentComments: 'Comentar',
            email: 'E-mail',
            profile: 'Perfil',
            phone: 'Telefone',
            status: 'Ativo/Inativo',
            actions: 'Ações',
            dimensions: 'Dimensões',
            depth: 'Profundidade',
            squareMeter: 'Metro quadrado',
            planName: 'Nome do plano',
            description: 'Descrição',
            modules: 'Módulos',
            allowed: 'Permitido',
            startDate: 'Início',
            startTime: 'Horário',
            teacher: 'Professor',
            dayOfWeek: 'Dia da semana',
            vacances: 'Vagas',
            endDate: 'Final',
            levels: 'Niveis',
            level: 'Nivel',
            active: 'Ativo',
            objective: 'Objetivo',
            contents: 'Conteúdos',
            textPTBR: 'Português',
            textES: 'Espanhol',
            textEN: 'Inglês',
            companyName: 'Denominação social',
            tradingName: 'Nome fantasia',
            document: 'Documento',
            registration: 'Matrícula',
            customerSuccess: 'Customer Success',
            cityState: 'Cidade - Estado',
            plan: 'Plano',
            type: 'Tipo',
            age: 'Idade',
            presence: 'Presença',
            pedagogicType: 'Tipo pedagógico',
            quantityQuestion: 'Perguntas',
            assessmentAccomplishedScore: 'Nota',
            current: 'Vigente',
            assessmentStatus: 'Status',
            questions: 'Perguntas',
            items: 'Itens',
            points: 'Nota',
            order: 'Ordem',
            published: 'Publicada',
            execute: 'Executa',
            hitRate: 'Taxa de acerto',
            comments: 'Comentários',
        },
        noEndDate: 'Sem data de expiração',
        noClassName: '[Turma sem nome]',
        noClassTeacher: '[Turma sem professor]',
        noComments: 'Aluno sem comentários',
        to: 'para',
        inactiveProfile: 'Este usuário está inativo',
        months: 'mes(es)',
        age: 'ano(s)',
        ready: 'Pronto',
        inProgress: 'Rascunho',
    },
    Profiles: [
        {
            text: 'Proprietário',
            textShow: 'Owner',
            value: '1',
        },
        {
            text: 'Coordenador',
            textShow: 'Coordinator',
            value: '2',
        },
        {
            text: 'Professor',
            textShow: 'Teacher',
            value: '3',
        },
        {
            text: 'Aluno',
            textShow: 'Student',
            value: '4',
        },
        {
            text: 'Customer Success',
            textShow: 'CustomerSuccess',
            value: '5',
        },
        {
            text: 'Gerente',
            textShow: 'Manager',
            value: '6',
        },
        {
            text: 'Administrador',
            textShow: 'Admin',
            value: '7',
        },
        {
            text: 'Secretária',
            textShow: 'Secretary',
            value: '8',
        },
        {
            text: 'Responsável',
            textShow: 'Responsible',
            value: '9',
        },
        {
            text: 'Suporte',
            textShow: 'Support',
            value: '10',
        },
        {
            text: 'Pedagogo',
            textShow: 'Educator',
            value: '11',
        },
        {
            text: 'Vendas',
            textShow: 'Seller',
            value: '12',
        },
        {
            text: 'Marketing',
            textShow: 'Marketing',
            value: '13',
        },
        {
            text: 'Desenvolvedor',
            textShow: 'Developer',
            value: '14',
        },
    ],
    Status: [
        {
            name: 'Ativo',
            value: true,
        },
        {
            name: 'Inativo',
            value: false,
        },
    ],
    YesNoOptions: [
        {
            name: 'Sim',
            value: true,
        },
        {
            name: 'Não',
            value: false,
        },
    ],
    Inputs: {
        selectAttendanceDate: 'Selecione a data da chamada',
        attendanceDate: 'Data da chamada',
        releaseDate: 'Data de lançamento',
        partnerSelect: 'Selecione um parceiro',
        name: 'Nome',
        nameClassGrade: 'Nome da turma',
        dateTime: 'Selecione data e hora',
        firstName: 'Primeiro nome',
        lastName: 'Sobrenome',
        gender: 'Gênero',
        birthday: 'Data de nascimento',
        cpf: 'CPF',
        email: 'E-mail',
        studentEmail: 'E-mail do aluno',
        telephone: 'Telefone para contato',
        postalCode: 'CEP',
        address: 'Endereço',
        addressNumber: 'Número',
        addressComplement: 'Complemento',
        neighborhood: 'Bairro',
        country: 'País',
        state: 'Estado',
        city: 'Cidade',
        weekdaySelect: 'Selecione um dia da semana',
        studentSelect: 'Selecione um aluno',
        levelSelect: 'Selecione um nível',
        teacherSelect: 'Selecione um professor',
        poolSelect: 'Selecione uma piscina',
        unitSelect: 'Selecione uma unidade',
        unitSelectSimple: 'Selecione uma unidade',
        unitTypeSelect: 'Selecione o tipo da unidade',
        entitySelect: 'Selecione o tipo da entidade',
        planSelect: 'Selecione um plano',
        plansSelect: 'Selecione os planos',
        profilesSelect: 'Selecione os perfis',
        customerSuccessSelect: 'Selecione um customer success',
        situationSelect: 'Selecione a situação',
        pedagogicTypeSelect: 'Selecione o tipo pedagógico',
        calendarSelect: 'Selecione uma data',
        calendarTypeSelect: 'Selecione o tipo do calendário',
        assessmentQuestionItemTypeSelect: 'Selecione o tipo da questão',
        clientSelect: 'Selecione o cliente',
        monthlyFee: 'Mensalidade',
        registration: 'Matrícula',
        platformAccessToggle: 'Tem acesso à plataforma?',
        poolName: 'Nome da piscina',
        poolDescription: 'Descrição da piscina',
        poolLength: 'Comprimento',
        poolWidth: 'Largura',
        poolDepth: 'Profundidade',
        numberOfStudents: 'Número de alunos',
        numberOfStudentsInClass: 'Número de alunos matriculados',
        classStartTime: 'Hora inicial',
        classEndTime: 'Hora final',
        weekdays: 'Dia da aula',
        tradingName: 'Nome fantasia',
        companyName: 'Razão social',
        document: 'Documento',
        stateRegistration: 'Inscrição Estadual',
        municipalRegistration: 'Inscrição Municipal',
        personalWebsite: 'Website',
        facebook: 'Facebook',
        instagram: 'Instagram',
        calendarDescription: 'Descrição do calendário',
        planLimitStudentsToggle: 'Ilimitado?',
        planLimitStudentsInput: 'Limite de alunos',
        planLimitStaffToggle: 'Ilimitado?',
        planLimitStaffInput: 'Limite de funcionários',
        planDescription: 'Descrição do plano',
        planColor: 'Cor do plano',
        portugueseLanguage: 'Português',
        englishLanguage: 'Inglês',
        spanishLanguage: 'Espanhol',
        toggleCurrentAssessment: 'Vigente',
        assessmentQuestion: 'Digite a pergunta da avaliação',
        assessmentQuestionItem: 'Digite o item desta pergunta',
        assessmentQuestionItemGrade: 'Valor deste item',
        accreditedName: 'Nome do credenciado',
        initialDate: 'Data inicial',
        endDate: 'Data final',
        availableCharacters: 'Caracteres disponíveis',
        rangeDate: 'Selecione um período',
        goalsSelect: 'Selecione um objetivo',
        statusSelect: 'Selecione um status',
        hasResponsibleSelect: 'Aluno com responsável',
        hasStudentSelect: 'Responsável com aluno',
        hasEmailSelect: 'Com/Sem email',
        plataformAccessSelect: 'Acesso a plataforma',
        contentsSelect: 'Selecione os conteúdos',
        staffSelect: 'Selecione o colaborador MGB',
        filterLevel: 'Nível(is)',
        filterPool: 'Piscina(s)',
        filterTeacher: 'Professor(es)',
        selectTeachers: 'Todos os professores',
        selectPools: 'Todas as piscinas',
        selectLevels: 'Todos os níveis',
        buyerSelect: 'Comprador',
        current: 'Vigente',
        points: 'Pontos:',
        questionItem: 'Digite o item desta pergunta',
        itemType: 'Tipo',
        itemPoints: 'Pontuação',
        order: 'Ordem',
        assessmentComments: 'Comentários do aluno',
        fileName: 'Nome do arquivo',
        description: 'Descrição',
        permissionSelect: 'Público/Privado',
        languageSelect: 'Selecione um idioma',
    },
    States: {
        Brazil: [
            {
                abbv: 'AC',
                full: 'Acre',
            },
            {
                abbv: 'AL',
                full: 'Alagoas',
            },
            {
                abbv: 'AP',
                full: 'Amapá',
            },
            {
                abbv: 'AM',
                full: 'Amazonas',
            },
            {
                abbv: 'BA',
                full: 'Bahia',
            },
            {
                abbv: 'CE',
                full: 'Ceará',
            },
            {
                abbv: 'DF',
                full: 'Distrito Federal',
            },
            {
                abbv: 'ES',
                full: 'Espírito Santo',
            },
            {
                abbv: 'GO',
                full: 'Goiás',
            },
            {
                abbv: 'MA',
                full: 'Maranhão',
            },
            {
                abbv: 'MT',
                full: 'Mato Grosso',
            },
            {
                abbv: 'MS',
                full: 'Mato Grosso do Sul',
            },
            {
                abbv: 'MG',
                full: 'Minas Gerais',
            },
            {
                abbv: 'PA',
                full: 'Pará',
            },
            {
                abbv: 'PB',
                full: 'Paraíba',
            },
            {
                abbv: 'PR',
                full: 'Paraná',
            },
            {
                abbv: 'PE',
                full: 'Pernambuco',
            },
            {
                abbv: 'PI',
                full: 'Piauí',
            },
            {
                abbv: 'RJ',
                full: 'Rio de Janeiro',
            },
            {
                abbv: 'RN',
                full: 'Rio Grande do Norte',
            },
            {
                abbv: 'RS',
                full: 'Rio Grande do Sul',
            },
            {
                abbv: 'RO',
                full: 'Rondônia',
            },
            {
                abbv: 'RR',
                full: 'Roraima',
            },
            {
                abbv: 'SC',
                full: 'Santa Catarina',
            },
            {
                abbv: 'SP',
                full: 'São Paulo',
            },
            {
                abbv: 'SE',
                full: 'Sergipe',
            },
            {
                abbv: 'TO',
                full: 'Tocantins',
            },
        ],
    },
    DaysOfWeek: [
        'Segunda-Feira',
        'Terça-Feira',
        'Quarta-Feira',
        'Quinta-Feira',
        'Sexta-Feira',
        'Sábado',
        'Domingo',
    ],
    Levels: [
        {
            abbreviaton: 'BB1',
            color: 'avtWhite',
            name: 'Bebê 1',
            id: 1,
        },
        {
            abbreviaton: 'BB2',
            color: 'avtWhite',
            name: 'Bebê 2',
            id: 2,
        },
        {
            abbreviaton: 'BB3',
            id: 3,
            color: 'avtYellow',
            name: 'Bebê 3',
        },
        {
            abbreviaton: 'ADAP',
            id: 4,
            color: 'avtOrange',
            name: 'Adaptação Infantil',
        },
        {
            abbreviaton: 'INIC',
            id: 5,
            color: 'avtRed',
            name: 'Iniciação Infantil',
        },
        {
            abbreviaton: 'AP1',
            id: 6,
            color: 'avtGreen',
            name: 'Aperfeiçoamento 1',
        },
        {
            abbreviaton: 'AP2',
            id: 7,
            color: 'avtLightBlue',
            name: 'Aperfeiçoamento 2',
        },
        {
            abbreviaton: 'AP3',
            id: 8,
            color: 'avtHeavyBlue',
            name: 'Aperfeiçoamento 3',
        },
        {
            abbreviaton: 'EQ',
            id: 9,
            color: 'avtYellow',
            name: 'Equipe',
        },
        {
            abbreviaton: 'FS',
            id: 10,
            color: 'avtBlack',
            name: 'Fast swim',
        },
        {
            abbreviaton: 'COND1',
            id: 11,
            color: 'avtBlack',
            name: 'Condicionamento 1',
        },
        {
            abbreviaton: 'COND2',
            id: 12,
            color: 'avtBlack',
            name: 'Condicionamento 2',
        },
        {
            abbreviaton: 'ADAP_AD',
            id: 13,
            color: 'avtBlack',
            name: 'Adaptação Adulto',
        },
        {
            abbreviaton: 'INIC_AD',
            id: 14,
            color: 'avtBlack',
            name: 'Iniciação Adulto',
        },
    ],
    Subtitles: {
        periods: 'Exibição de Aulas agrupadas por períodos',
        classes: 'Aulas',
        profiles: 'Perfis',
        responsibles: 'Responsáveis',
        units: 'Unidades',
        students: 'Alunos',
        registrationData: 'Dados cadastrais',
        contractualData: 'Dados contratuais',
        socialNetwork: 'Site e redes sociais',
        locationData: 'Dados da unidade',
        locationStore: 'Lista de lojistas',
        aboutLesson: 'Sobre a aula',
        aboutStudents: 'Sobre os alunos',
        questions: 'Perguntas',
        questionItems: 'Itens da pergunta',
        aboutAssessment: 'Sobre a avaliação',
        assessmentPerformance: 'Performance geral da avaliação',
        assessmentComentary: 'Comentários da avaliação',
        assessmentDetails: 'Detalhes da avaliação',
    },
    Descriptions: {
        performanceDescription:
            'resumo do desempenho do aluno nesta avaliação, abaixo está listado as questões que foram aplicadas',
        assessmentDetailsDescription:
            'detalhamento das questões aplicadas nesta avaliação, a análise abaixo é feita de forma individual em cada questão',
    },
    OccupancyMap: {
        noEvents: 'Sem turmas',
        classes: 'Turma(s)',
        vacancys: 'Total de Vagas',
        enrollment: 'Vagas Ocupadas', // N de Matrículas (label generica por solicitação)
        occupancy: 'Ocupação',
        seeLesson: 'Ver aula',
        seeClass: 'Ver turma',
        teacher: 'Professor',
    },
    AssessmentItemType: [
        {
            name: 'Executa',
            value: 0,
        },
        {
            name: 'Valor',
            value: 1,
        },
        {
            name: 'Tempo',
            value: 2,
        },
    ],
    AssessmentStatus: [
        'EM ANDAMENTO',
        'FINALIZADA',
        'DESPUBLICADA',
        'PUBLICADA',
    ],
    ScoreStatus: [
        'Não executa',
        'Em desenvolvimento',
        'Regular',
        'Bom',
        'Ótimo',
        'Excelente',
    ],
    AssessmentApplication: {
        comments: 'Insira comentários para os alunos',
        commentsButton: 'Encerrar comentários',
        finish: 'Finalizar avaliação',
    },
    Rightpanel: {
        info: 'Informações',
        addFile: 'Adicionar arquivo',
        editFile: 'Editar arquivo',
        seeFile: 'Visualizar',
        download: 'Baixar',
        startDate: 'Início',
        endDate: 'Término',
        plans: 'Planos',
        profiles: 'Perfis',
        extension: 'Extensão',
        dragFile: 'Arraste um arquivo para cá',
        dragImage: 'Arraste uma imagem para cá',
        picture: 'Coloque sua foto',
        selectFile: ['Ou se preferir...', 'Selecione um arquivo'],
        selectImage: ['Ou se preferir...', 'Selecione uma imagem'],
        share: 'Compartilhar',
    },
    EmptyState: {
        notFound: 'Não encontramos nada por aqui',
        createNewAssessment: 'iniciando uma avaliação em um aluno',
        createNewRegistry: 'Mas você pode criar um novo registro',
        clickingHere: 'clicando aqui',
    },
    Filter: {
        title: 'Filtro',
        label: 'Filtros ativos',
        Status: 'Status',
        Plans: 'Planos',
        Profiles: 'Perfis',
        StartDate: 'Data inicial',
        StartTime: 'Hora inicial',
        EndDate: 'Data final',
        EndTime: 'Hora final',
        TeacherPublicIds: 'Professores',
        StudentPublicIds: 'Alunos',
        NumberOfStudents: 'Número de alunos',
        MinNumberOfStudents: 'Min. Número de alunos',
        MaxNumberOfStudents: 'Max. Número de alunos',
        LevelPublicIds: 'Níveis',
        ClassTeachingAreaPublicIds: 'Piscinas',
        DayOfTheWeeks: 'Dias da semana',
        HasResponsible: 'Aluno com responsável',
        HasEmail: 'Acesso a plataforma',
        HasDependant: 'Responsável com aluno',
        Name: 'Nome',
        Document: 'Documento',
        CompanyName: 'Denominação social',
        TradingName: 'Nome fantasia',
        Registration: 'Matrícula',
        Email: 'E-mail',
        Telephone: 'Telefone',
        AssessmentStatus: [
            {
                name: 'Em andamento',
                value: true,
            },
            {
                name: 'Finalizada',
                value: false,
            },
            {
                name: 'Publicada',
                value: false,
            },
            {
                name: 'Despublicada',
                value: false,
            },
        ],
    },
}
